import { createClient } from '@supabase/supabase-js';

// Helper to safely access environment variables in Vite
const getEnvVar = (key: string) => {
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // @ts-ignore
    return import.meta.env[key] || import.meta.env[`VITE_${key}`];
  }
  return '';
};

const supabaseUrl = getEnvVar('SUPABASE_URL') || getEnvVar('REACT_APP_SUPABASE_URL');
const supabaseAnonKey = getEnvVar('SUPABASE_ANON_KEY') || getEnvVar('REACT_APP_SUPABASE_ANON_KEY');

// Create a client if keys exist, otherwise create a dummy client that warns on use
// This prevents the app from crashing immediately on load if keys are missing
export const supabase = (supabaseUrl && supabaseAnonKey) 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : {
      from: () => ({
          select: () => Promise.resolve({ data: [], error: { message: 'Supabase keys missing (Demo Mode)' } }),
          insert: () => Promise.resolve({ data: [], error: { message: 'Supabase keys missing (Demo Mode)' } }),
          update: () => Promise.resolve({ data: [], error: { message: 'Supabase keys missing (Demo Mode)' } }),
          delete: () => Promise.resolve({ data: [], error: { message: 'Supabase keys missing (Demo Mode)' } }),
      }),
      auth: {
          getSession: () => Promise.resolve({ data: { session: null }, error: null }),
          onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
          signInWithPassword: () => Promise.resolve({ data: {}, error: { message: 'Supabase keys missing' } }),
      }
  } as any;